/* eslint react/prop-types: 0 */
import React from 'react'
import Select from 'react-select'
import { FormInput } from 'camino-react'

const ConvertToTicket = ({
  operations: {
    queue_id: queueID,
    client_contact_id: clientContactID
  },
  options: { employees, queues },
  update
}) => (
  <div>
    <FormInput label="Ticket Queue">
      <Select
        value={queueID}
        onChange={e => update('queue_id', e.value)}
        options={queues}
      />
    </FormInput>

    <FormInput label="Ticket Contact">
      <Select
        value={clientContactID}
        onChange={e => update('client_contact_id', e.value)}
        options={employees}
      />
    </FormInput>
  </div>
)

export default ConvertToTicket
